import React from 'react';
import PropTypes from 'prop-types';
import ClubLink from '../club-link';

const ProfileLink = ({ children, teamId, playerId, name }) => {
  if (!playerId || !teamId) {
    return children;
  }

  return (
    <ClubLink
      route="team.squad.profile"
      params={{ teamId, profileType: 'player', profileId: playerId, _profile: name }}
    >
      <a>{children}</a>
    </ClubLink>
  );
};

ProfileLink.propTypes = {
  children: PropTypes.shape().isRequired,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.any]),
  playerId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

ProfileLink.defaultProps = {
  teamId: null,
};

export default ProfileLink;
